


































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import EditableField from "@/components/common/EditableField.vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Choices from "@/store/modules/Choices";
import { NotificationEventBus } from "@/EventBus";
import ScoringKeys from "@/store/modules/ScoringKeys";
import FactorGroupScoringDefinition from "@/components/scoring-definition/FactorGroupScoringDefinition.vue";
import FactorScoringDefinitionButtonTrigger
    from "@/components/scoring-definition/FactorScoringDefinitionButtonTrigger.vue";
import ScoringKeyButtonTrigger from "@/components/scoring-key/ScoringKeyButtonTrigger.vue";
import Modelling from "@/store/modules/Modelling";
import { FactorGroup, FactorResource } from "@/api/model/FactorResource";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import Decisions from "@/store/modules/Decisions";

const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions)
const choicesModule = getModule(Choices)
const workspaceOptionsModule = getModule(WorkspaceOptions);
const scoringKeysModule = getModule(ScoringKeys)
@Component({
    components: {
        ButtonScoringKeyTrigger: ScoringKeyButtonTrigger,
        ButtonScoringDefinitionTrigger: FactorScoringDefinitionButtonTrigger,
        FactorGroupScoringDefinition,
        EditableField
    }
})
export default class ResourceEditingPanel extends Vue {

    private updating = false;

    get selectedElement() {
        return workspaceOptionsModule.selectedElement;
    }

    get resourceId(): string | undefined {
        return this.selectedElement ? this.selectedElement.id : undefined;
    }

    get viewpointId(): any {
        if (this.selectedElement && !this.selectedElement.isTemplate) {
            return this.selectedElement.viewpointId ? this.selectedElement.viewpointId : null;
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get workingFactorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get viewpointFactorResource() {
        if (this.viewpointId && this.resourceId) {
            return viewpointsModule.viewpointFactorResources[this.viewpointId][this.resourceId]
        }
    }

    get resource() {
        if (this.selectedElement && this.selectedElement.id) {
            switch (this.selectedElement.type) {
                case "FACTOR":
                case "FACTOR_GROUP":
                    return this.selectedElement.isTemplate ? this.workingFactorResources[this.selectedElement.id] : this.viewpointFactorResource
                case "VIEWPOINT":
                    return viewpointsModule.decisionViewpointsMap ? viewpointsModule.decisionViewpointsMap[this.viewpointId] : null;
            }
        }
    }

    get resourceType() {
        return this.selectedElement ? this.selectedElement.type : null;
    }

    get isNameDescriptionEditable() {
        return this.selectedElement
            && ['FACTOR', 'FACTOR_GROUP'].includes(this.selectedElement.type)
            && this.selectedElement.isTemplate
    }

    private async nameChange(value: any) {
        if (!this.selectedElement || !this.resourceType) return;
        let editingResource = JSON.parse(JSON.stringify(this.resource))
        editingResource.name = value;
        await this.updateModelFactor(editingResource);

    }

    private async updateSummaryScoringFunction(value: string) {
        if (!this.selectedElement || !this.resourceId) return;
        if (this.selectedElement.isTemplate) {
            let factorResource = this.factorResources[this.resourceId] as FactorGroup
            factorResource.summaryScoringFunction = value;
            await this.updateModelFactor(factorResource);
        } else {
            let viewpointFactorResource: ViewpointFactorResource;
            if (!this.viewpointFactorResource) {
                viewpointFactorResource = {
                    viewpointId: this.viewpointId,
                    id: this.resourceId
                }
            } else {
                viewpointFactorResource = this.viewpointFactorResource
            }
            viewpointFactorResource.summaryScoringFunction = value;
            await this.updateViewpointFactor(viewpointFactorResource);
        }
    }

    private async updateModelFactor(factor: FactorResource) {
        NotificationEventBus.emitProcessingMessage()
        try {
            await modellingModule.updateFactorResource(factor)
            NotificationEventBus.emitSuccessMessage()
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
    }


    private async updateViewpointFactor(viewpointFactorResource: ViewpointFactorResource) {
        NotificationEventBus.emitProcessingMessage()
        try {
            await viewpointsModule.putViewpointFactor(viewpointFactorResource)
            NotificationEventBus.emitSuccessMessage()
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
    }


}
